import React from 'react'
import {KTIcon} from '../../../../_metronic/helpers'
import {ISelectOption} from '../../../utils/core/_model'

type Props = {
  categoriesOptions: ISelectOption[]
  selectedCategoryId: number | null
  onSelectCategoryId: (id: number) => void
}

const ArticleFilter = ({categoriesOptions, selectedCategoryId, onSelectCategoryId}: Props) => {
  return (
    <div>
      <button
        type='button'
        className='btn btn-light-primary me-3'
        id='dropdownMenuButton'
        data-bs-toggle='dropdown'
        aria-haspopup='true'
        aria-expanded='false'
      >
        <KTIcon iconName='filter' className='fs-2' />
        Filter
      </button>
      <div
        className='dropdown-menu menu menu-sub menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-300px w-md-325px py-4'
        aria-labelledby='dropdownMenuButton'
      >
        <div className='mb-10'>
          <div className='px-7 py-5'>
            <div className='fs-5 text-gray-900 fw-bolder'>Filter Options</div>
          </div>

          <div className='px-7 py-5'>
            <label className='form-label fs-6 fw-bold'>Category</label>
            <select
              className='form-select form-select-solid fw-bolder'
              data-kt-select2='true'
              placeholder='Select categories'
              data-hide-search='true'
              value={selectedCategoryId ? selectedCategoryId : 'Select categories'}
              onChange={(e) => {
                onSelectCategoryId(parseInt(e.target.value))
              }}
            >
              <option value='0'>Select categories</option>

              {categoriesOptions.map((category) => (
                <option value={category.id}>{category.label}</option>
              ))}
            </select>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ArticleFilter
